import { render, staticRenderFns } from "./Backtop.vue?vue&type=template&id=75c92b3c&scoped=true&"
import script from "./Backtop.vue?vue&type=script&lang=js&"
export * from "./Backtop.vue?vue&type=script&lang=js&"
import style0 from "./Backtop.vue?vue&type=style&index=0&id=75c92b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c92b3c",
  null
  
)

export default component.exports